import React, { useCallback } from 'react';
import { LimitedAccessPlaceholder, Button } from '@nextiva/next-ui';
import { redirectToRolesAndPermissions } from 'utils';

const Forbidden = () => {
  const handlePermissionClick = useCallback(() => {
    redirectToRolesAndPermissions();
  }, []);

  return (
    <LimitedAccessPlaceholder
      renderButtons={() => (
        <Button id="go-to-pa" onClick={handlePermissionClick} kind="primary">
          Change Permission
        </Button>
      )}
    />
  );
};

export default Forbidden;
